// ERP-only products created inline from the Create Item product search.
// See server/src/controllers/product/erpProductController.js

/* eslint-disable no-undef */
import { axiosInstance } from '../common';

const ENDPOINT_ERP_PRODUCT = '/product';

// Resolves to { id, name, existing } — `existing` is true when an ERP
// product with that name already sits in the subcategory.
export async function createErpProduct({ name, category_id, lang }) {
    return axiosInstance.post(ENDPOINT_ERP_PRODUCT, { name, category_id, lang })
        .then(({ data }) => data)
}

// Sets an ERP product's image from an uploaded temp image id
// (uploadFileFromObject). Resolves to { main_photos }.
export async function updateErpProductPhoto(productId, imageId) {
    return axiosInstance.post(`${ENDPOINT_ERP_PRODUCT}/${productId}/photo`, { image_id: imageId })
        .then(({ data }) => data)
}

// Creates/updates a CMS product in the ERP from the CMS detail API (a search
// hit that is not in the ERP yet). Resolves to { id }.
export async function importCmsProduct(cmsId, lang) {
    return axiosInstance.post(`${ENDPOINT_ERP_PRODUCT}/import`, { cms_id: cmsId, lang })
        .then(({ data }) => data)
}

// Removes an ERP product's image.
export async function removeErpProductPhoto(productId) {
    return axiosInstance.delete(`${ENDPOINT_ERP_PRODUCT}/${productId}/photo`)
        .then(({ data }) => data)
}
